import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCurrency, unFormatPercentage } from '@/common/utils/unFormatters'
import { UpdateContractFeeDetailsSchema } from '@/features/privateCompanies/schemas/contract/updateFeeDetails.schema'
import { useMutation } from '@tanstack/react-query'
import { CompanyContractType } from '../../types/companyContract.type'

interface UseUpdateContractFeeDetails {
  contract?: CompanyContractType
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateContractFeeDetails = ({ contract, onSuccess, onError }: UseUpdateContractFeeDetails) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContractFeeDetails'],
    mutationFn: async ({ data, deletedFees }: { data: UpdateContractFeeDetailsSchema; deletedFees: { id: string; _destroy: boolean; }[] }) => {
      const payload = {
        contract_fees_attributes: [
          ...deletedFees,
          ...data?.contract?.contract_fees_attributes?.map((fee) => ({
            id: fee.id || undefined,
            fee_template_id: !fee.id ? fee.fee_template_id : undefined,
            main_fee: !!fee.main_fee,
            value: fee?.calculate_as === 'percentage' ? unFormatPercentage(fee?.value) : unFormatCurrency(fee?.value),
          })),
        ],
      }

      await privateAxios.put(`/client/contracts/${contract?.id}/update_contract_fees_information`, {
        contract: payload,
      })
    },
    onSuccess,
    onError,
  })
}
